<template>
  <div :class="dataTable ? '' : 'pb-3'" @click.shift="editRessource">
    <v-checkbox v-model="saisie"
                :class="cssClasses"
                :off-icon="showRequired && disabled ? offIcon : '$checkboxOff'"
                :indeterminate="indeterminate"
                dense
                :hide-details="dataTable ? dataTable : false"
                :label="editFieldInfo.ressource.label"
                :error="error"
                :readonly="disabled"
                :ripple="false"
                color="#2a97da">
      <template #append>
        <v-icon v-if="editFieldInfo.ressource.helpHtmlId > 0"
                class="ms-2 help-icon"
                @click="toggleHelpDialog">
          fas fa-circle-info
        </v-icon>
      </template>
    </v-checkbox>

    <help-dialog v-if="showHelpDialog && editFieldInfo.ressource.helpHtmlId > 0"
                 :content="helpHtml"
                 :open="showHelpDialog"
                 @close="toggleHelpDialog">
    </help-dialog>
  </div>
</template>

<script lang="ts">
  import { FieldError, FieldInfo } from "@/framework/base/components/FieldInfo";
  import { type EditRessource } from '@/framework/base/helpers/Ressources';
  import HelpDialog from '@/framework/base/components/HelpDialog.vue';
  import { Ressources } from '@/framework/base/helpers/Ressources';
  import { defineComponent, type PropType } from "vue";
  import { storeSession } from '@/generated/stores';
  import UserProfile, { EnumProfile } from '@/framework/base/classes/UserProfile';

  export let cbEditRessource: EditRessource | undefined = undefined;

  export function setEditRessource(editRessource: EditRessource) {
    cbEditRessource = editRessource;
  }

  export default defineComponent({
    components: { HelpDialog },
    props: {
      value: {
        type: Object as PropType<boolean | null>,
        required: true
      },
      contextId: {
        type: Number,
        required: true
      },
      editFieldInfo: {
        type: Object as PropType<FieldInfo>,
        required: true
      },
      required: {
        type: Boolean
      },
      disabled: {
        type: Boolean
      },
      dataTable: {
        type: Boolean
      },
      showMissing: {
        type: Boolean
      }
    },
    created(): void {
      this.initValue = this.value;
      this.error = false;
    },
    data() {
      const initValue = null as boolean | null
      return {
        initValue,
        error: false,
        editing: false,
        offIcon: 'fas fa-square',
        iconRequired: 'mdi-dots-square',
        lastContextId: 0,
        showHelpDialog: false,
        loadedHelpHtml: '',
        cbEditRessource
      };
    },
    computed: {
      showRequired(): boolean {
        return this.required && this.value == null;
      },
      indeterminate(): boolean {
        return this.value == null;
      },
      saisie: {
        get(): boolean {
          if (this.contextId != this.lastContextId) {
            this.setError(false);
            this.setLastContextId(this.contextId);
            this.$emit('context', this.value);
          }
          if (this.showMissing != undefined && this.showMissing) {
            this.checkError()
          }
          return this.value ? this.value : false;
        },
        set(value: boolean) {
          this.editing = true;
          this.setValue(value);
          if (this.error) {
            this.error = false;
            this.$emit('error', new FieldError(0, "", this.error));
          }
        }
      },
      cssClasses(): string {
        const classes = ['check-field'];
        if (this.disabled) {
          classes.push('border-bottom-dashed');
        } else if (!this.disabled && !this.dataTable) {
          classes.push('border-bottom-solid');
        }
        return classes.join(' ');
      },
      helpHtml(): string {
        if (this.showHelpDialog && this.loadedHelpHtml == '' && this.editFieldInfo.ressource.helpHtmlId > 0) {
          this.getHelpResources(this.editFieldInfo.ressource.helpHtmlId);
        }    
        return this.loadedHelpHtml;
      }
    },

    methods: {
      setError(value: boolean) {
        this.error = value;
      },
      setLastContextId(value: number) {
        this.lastContextId = value;
      },
      getHelpResources(value: number) {
        Ressources.getHelp(value).then((res) => {
          this.loadedHelpHtml = res.html;
        });
      },
      checkError(): boolean {
        this.error = false;
        if (this.required && this.value == null) {
          this.error = true;
          this.$emit('error', new FieldError(0, "", this.error));
        }
        return this.error;
      },
      setValue(value: boolean): void {
        this.$emit("updated", value);
      },
      touch(): boolean {
        const error = this.error;
        this.error = this.showRequired;
        if (error != this.error) {
          this.$emit('error', new FieldError(0, "", this.error));
        }
        return this.error;
      },
      editRessource() {
        const user = storeSession.connectedUser;
        if (user) {
          const isAdmin = UserProfile.hasProfile(user, EnumProfile.admin);
          if (isAdmin && cbEditRessource) {
            cbEditRessource(this.editFieldInfo.ressource, this.updateRessource);
          }
        }
      },
      missing(): boolean {
        return this.required && !this.value;
      },
      updateRessource() {
        this.loadedHelpHtml = '';
      },
      toggleHelpDialog() {
        this.showHelpDialog = !this.showHelpDialog;
      }
    }
  })

</script>
